// extracted by mini-css-extract-plugin
module.exports = {"password":"CompanyAngles-password-3n8bj"};